<template>
  <div class="">
    <h2 class="page_title ab c5a">インボイス登録番号</h2>
    <div class="mt12 pt16 pb16">
      <div class="bdb">
        <p class="rb">T{{ invoiceNumber }}</p>
      </div>
    </div>
    <div class="">
      <p class="invoice_text ab color_red">課税事業者の方（インボイス発行事業者）は、税務署より発行された「インボイス発行事業者登録番号（適格請求書発行事業者登録番号）」（Tから始まる13桁の数字）を登録してください。</p>
      <div class="mt24">
        <button @click="editInvoiceNumber" type="button" name="button" class="btn btn_yellow">編集</button>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/components/common/SectionTitle';

export default {
  props: ['invoiceNumber'],
  components: {
    SectionTitle,
  },
  methods: {
    editInvoiceNumber() {
      this.$emit('editInvoiceNumber');
    }
  }
}
</script>

<style lang="css" scoped>
.color_red {
  color: #FF3A3A;
}
</style>



// WEBPACK FOOTER //
// src/components/member/invoice/GetInvoiceNumber.vue